import { render, staticRenderFns } from "./sentMsgDialog.vue?vue&type=template&id=67471d1a&"
import script from "./sentMsgDialog.vue?vue&type=script&lang=js&"
export * from "./sentMsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./sentMsgDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports